module.exports = __webpack_public_path__ + "img/SalamDisabeld.66db42e2.svg";